// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.iUWrgkJlmJc5UD5I{text-align:center}.U3nzPmmwHfkZpBmo{min-height:24px;margin-top:8px}.kLwM7kxXHLsOi1Rb{justify-items:right}.kLwM7kxXHLsOi1Rb .u0FYUX3Ugbs174lc{width:fit-content;grid-row:1}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"awaitingApprovalChips": `iUWrgkJlmJc5UD5I`,
	"row": `U3nzPmmwHfkZpBmo`,
	"reviewCycleStatusChipsGrid": `kLwM7kxXHLsOi1Rb`,
	"statusChip": `u0FYUX3Ugbs174lc`
};
export default ___CSS_LOADER_EXPORT___;
